
import clientAuth from "../clientAuth"
export default {
    index: () => clientAuth.get(`unavailabledate/index`), 
    store: (userData) => clientAuth.post('unavailabledate/store', { json: userData }),       
    show:(id)=>clientAuth.get(`unavailabledate/show/${id}`),
    update: (id,userData) => clientAuth.post(`unavailabledate/update/${id}`, { json: userData }),
    destroy: (id) => clientAuth.delete(`unavailabledate/destroy/${id}`),
};